import { Action } from "../../models/Action";
import { UPDATE_BASKET_LENGTH, UPDATE_CALENDAR_SALE_QNT_STATE, UPDATE_SELECT_SEATS } from "./basketTypes";
import { SelectedSeats } from "../../models/SelectedSeats";
import { QntStateItem } from "../../models/QntStateItem";

export interface BasketState {
  loading: boolean;
  selectedSeats: SelectedSeats[];
  basketLength: number;
  basketTotal: number;
  calendarSaleQntState: QntStateItem[];
}

const initialBasket: BasketState = {
  loading: false,
  selectedSeats: [],
  basketLength: 0,
  basketTotal: 0,
  calendarSaleQntState: [],
};

export default function basketReducer(basketState = initialBasket, action: Action<any>) {
  switch (action.type) {
    case UPDATE_SELECT_SEATS:
      return {
        ...basketState,
        selectedSeats: action.payload,
      };
    case UPDATE_BASKET_LENGTH:
      return {
        ...basketState,
        basketLength: action.payload,
      };
    case UPDATE_CALENDAR_SALE_QNT_STATE:
      return {
        ...basketState,
        calendarSaleQntState: action.payload,
      };
    default:
      return basketState;
  }
}
